"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.IoResearchOutpostRebalanced = void 0;
var Tags_1 = require("../../Tags");
var PreludeCard_1 = require("../../prelude/PreludeCard");
var Resources_1 = require("../../../Resources");
var CardName_1 = require("../../../CardName");
var CardRenderer_1 = require("../../render/CardRenderer");
var IoResearchOutpostRebalanced = (function (_super) {
    __extends(IoResearchOutpostRebalanced, _super);
    function IoResearchOutpostRebalanced() {
        return _super.call(this, {
            name: CardName_1.CardName.IO_RESEARCH_OUTPOST_REBALANCED,
            tags: [Tags_1.Tags.JOVIAN, Tags_1.Tags.SCIENCE],
            metadata: {
                cardNumber: 'P16',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.titanium(1); }).br;
                    b.cards(2);
                }),
                description: 'Increase your titanium production 1 step. Draw 2 cards.',
            },
        }) || this;
    }
    IoResearchOutpostRebalanced.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.TITANIUM, 1);
        player.drawCard(2);
        return undefined;
    };
    return IoResearchOutpostRebalanced;
}(PreludeCard_1.PreludeCard));
exports.IoResearchOutpostRebalanced = IoResearchOutpostRebalanced;
//# sourceMappingURL=IoResearchOutpostRebalanced.js.map